import React, { useEffect, useState, useCallback } from 'react';
import { Schema } from 'jsonschema';

import JsonField from '../Controls/JsonField/JsonField';
import { validate } from '../../common/validators';

interface JsonSchemaFieldProps {
    jsonSchema: Schema;
    onChange: (fieldValue: string, schemaError: string | null) => void;
}

const JsonSchemaField: React.FC<JsonSchemaFieldProps> = ({ jsonSchema, onChange }) => {
    const [jsonField, setJsonField] = useState('');
    const [jsonError, setJsonError] = useState<string | null>(null);

    useEffect(() => {
        if (!jsonField || !jsonSchema || !onChange) {
            return;
        }
        const parsingError = validate(jsonField, { isJson: true, jsonSchema });

        setJsonError(parsingError);
        if (onChange) {
            onChange(jsonField, parsingError);
        }
    }, [jsonField, jsonSchema, onChange]);

    const handleChange = useCallback((_, value: string) => {
        setJsonField(value);
    }, []);

    return (
        <JsonField
            field={{ value: jsonField, error: jsonError }}
            style={{ width: 420, height: 169, minHeight: 40 }}
            inputStyle={{ height: 153 }}
            errorStyle={{ fontSize: 10 }}
            changed={handleChange}
        />
    );
};

export default React.memo(JsonSchemaField);
